import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminGet } from './adminApi';
import { toast } from 'sonner';

const ROWS = [
  ['Compliance tier', v => v.compliance_tier === 'REGULATED' ? 'Regulated (locked)' : v.compliance_tier],
  ['Deployment', v => v.deployment],
  ['Device QR (on logger)', () => 'Yes'],
  ['Passport QR page (on product)', v => v.passport_page === 'LOGIN_ONLY' ? 'Login-only' : 'Public'],
  ['Location visible to Track0tic staff', v => v.location_visible_to_staff ? 'Yes' : 'No · customer key'],
  ['Maker-checker', v => v.maker_checker],
  ['Main device types', v => v.main_device_types],
];

export default function NewCustomerVerticalPage() {
  const [verticals, setVerticals] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    adminGet('/verticals').then(setVerticals).catch(e => toast.error(e.message));
  }, []);

  const pick = (v) => {
    if (v.wizard_disabled) { toast.info(`${v.name} setup available in Phase 4`); return; }
    navigate(`/admin/tenants/new/${v.code}`);
  };

  const tableVerticals = verticals.filter(v => v.code !== 'OTHER');

  return (
    <div className="p-8 max-w-7xl" data-testid="new-customer-vertical-page">
      <p className="text-sm mb-1" style={{ color: '#6b7069' }}>New tenant · Step 1</p>
      <h1 className="text-4xl font-bold mb-2" style={{ color: '#1B1D1C' }}>Which industry is this customer in?</h1>
      <p className="text-sm mb-6" style={{ color: '#6b7069' }}>The vertical decides the setup steps, default features, compliance tier and where their data can live.</p>

      <div className="grid md:grid-cols-3 gap-4 mb-6">
        {verticals.map(v => (
          <button key={v.code} data-testid={`vertical-card-${v.code}`} onClick={() => pick(v)}
            className="text-left rounded-lg border p-5 transition-transform hover:-translate-y-0.5"
            style={v.wizard_disabled
              ? { background: '#1B1D1C', borderColor: '#1B1D1C', color: 'white', opacity: 0.85, cursor: 'not-allowed' }
              : v.code === 'OTHER'
                ? { background: 'white', border: '1.5px dashed #C9C6BC' }
                : { background: 'white', borderColor: '#E5E3DC' }}>
            <div className="flex items-center justify-between">
              <p className="text-xl font-bold">{v.name}</p>
              {v.wizard_disabled && <span className="px-2 py-0.5 rounded text-xs" style={{ background: '#0B6B55', color: 'white' }}>Phase 4</span>}
            </div>
            <p className="text-sm mt-1.5" style={{ color: v.wizard_disabled ? '#b8bdb9' : '#6b7069' }}>
              {v.description}{v.wizard_disabled ? ' Setup available in Phase 4.' : ''}
            </p>
          </button>
        ))}
      </div>

      <div className="rounded-lg border bg-white p-5 overflow-x-auto" style={{ borderColor: '#E5E3DC' }} data-testid="vertical-comparison-table">
        <h2 className="text-lg font-bold mb-3" style={{ color: '#1B1D1C' }}>What each vertical sets by default</h2>
        <table className="w-full text-sm">
          <thead><tr className="text-left" style={{ color: '#6b7069' }}>
            <th className="py-2 font-medium"></th>
            {tableVerticals.map(v => <th key={v.code} className="font-medium" style={v.code === 'BFSI' ? { color: '#0B6B55' } : undefined}>{v.name.split(',')[0]}</th>)}
          </tr></thead>
          <tbody>
            {ROWS.map(([label, fn]) => (
              <tr key={label} className="border-t" style={{ borderColor: '#EDEBE4' }}>
                <td className="py-2.5" style={{ color: '#6b7069' }}>{label}</td>
                {tableVerticals.map(v => (
                  <td key={v.code} className={v.code === 'BFSI' ? 'font-bold' : ''}>{fn(v) || '—'}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
